<template>
  <div class="divFrameWork">
    <slot></slot>
    <div class="divContent">
      <p>{{ navTitle }}</p>
      <img
        v-lazy="{
          src: img,
          loading: require('./../../../../../assets/wheelplanting.jpg'),
        }"
      />
      <ul v-if="description.length>0">
        <li v-for="item in description" :key="item">
          <em></em><span>{{ item }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      navTitle: "",
      img: "",
      description: [],
    };
  },
  watch: {
    data(obj) {
      if (obj) {
        this.navTitle = obj.navTitle;
        let tuWen = obj.tuWen;
        if (tuWen && tuWen.image) {
          this.img = tuWen.image.url;
          this.description = tuWen.description
            ? tuWen.description.split("\n")
            : [];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/frameWorkWidge.scss";
</style>
